import React from "react";

import "./styles.scss";

interface IFieldProps {
  type?: string;
  value: any;
  disabled?: boolean;
  placeholder: string;
  name: string;
  onChange: (e: any) => void;
  labelText?: string;
  className?: string;
}

const TextArea: React.FC<IFieldProps> = (props) => {
  const disableStyle = props.disabled ? "form-row__input_disable" : "";
  return (
    <div className={`form-row ${props.className}`}>
      {props.labelText && (
        <label className={`form-row__label`} htmlFor={props.name}>
          {props.labelText}
        </label>
      )}
      <textarea
        className={`form-row__text-area ${disableStyle}`}
        value={props.value}
        placeholder={props.placeholder}
        name={props.name}
        onChange={props.onChange}
      />
    </div>
  );
};

export default TextArea;
